import React, { useContext, useState } from 'react';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import {
  Actions,
  WarningMessageModal,
  Tabs,
  BorderGradient,
  IconWithText,
  Button,
  ConfirmDelete,
} from 'Components';
import history from 'src/history';
import './PrepaidRequestHeader.css';

const PrepaidRequestHeader = (props) => {
  const [openWarningMessage, setOpenWarningMessage] = useState({ isSupplyOpen: false, isJobOpen: false, });
  const { deletionState, dispatch } = useContext(DeletionContext);

  const handleNewJobProceed = () => {
    history.push('/submissions/new');
  };
  const handleNewSupplyProceed = () => {
    history.push('/supplies/new');
  };
  const handleCancle = () => {
    setOpenWarningMessage({ isSupplyOpen: false, isJobOpen: false, });
  };
  const handleNewJobOnClick = () => {
    if (props.isSubmissionWarningON === 'ON') {
      setOpenWarningMessage({ isSupplyOpen: false, isJobOpen: true, });
    } else {
      history.push('/submissions/new');
    }
  };
  const handleNewOrdenOnClick = () => {
    //if (props.isSupplyWarningON === 'ON') {
    //    setOpenWarningMessage({ isSupplyOpen: true, isJobOpen: false, });
    //} else {
    //  history.push('/supplies/new');
    //}
    props.setAppState({isPrepaidOrder: true});
    history.push('/submissions/new');
  };

  return (
      <div className="Prepaid-Request-header">
        <div style={{
                display: 'flex',
                alignItems: 'end',
                justifyContent: 'end',
                gap: '10px',
                padding: '1rem',
            }}>
            {deletionState.isDeletionModeActive ? (
                <div
                    style={{
                    display: 'flex',
                    alignItems: 'end',
                    justifyContent: 'end',
                    gap: '10px',
                    }}
                >
                    <Button
                    className="button button--primary"
                    onClick={() => {
                        dispatch({
                        type: DELETE_ACTIONS.ACTIVATE_DELETE_CONFIRMATION,
                        });
                    }}
                    disabled={!(deletionState.selectedItems.length > 0)}
                    >
                    <span>{i18n.t('common:Delete')}</span>
                    </Button>
                    <Button
                    className="button button--primary"
                    onClick={() =>
                        dispatch({
                        type: DELETE_ACTIONS.DEACTIVATE_DELETION_MODE,
                        })
                    }
                    >
                    <span>{i18n.t('common:Cancel')}</span>
                    </Button>
                </div>
            ) : null}

            {deletionState.isDeleteConfirmationActive && (
                <ConfirmDelete
                    title={i18n.t('multiDeletion:MultiDeleteRecordsConfirmation')}
                    onCancelDelete={() => {
                    dispatch({
                        type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION,
                    });
                    }}
                    onProceedDelete={() => {
                    props.deleteSelectedItems(deletionState.selectedItems);
                    dispatch({
                        type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION,
                    });
                    }}
                />
            )}

            <IconWithText
                onClick={handleNewJobOnClick}
                icon="add_circle"
                text={i18n.t('jobs:NewJob')}
                textOrientation="before"
            />
            <IconWithText
                onClick={handleNewOrdenOnClick}
                icon="add_circle"
                text={i18n.t('orders:NewOrder')}
                textOrientation="before"
            />
        </div>

        <BorderGradient />

        <div className="Prepaid-Request-header__tabs">
          <Tabs
            onClick={props.onTabsClick}
            tabs={props.tabs}
            labels={props.tabs.map((tab) => i18n.t(`prepaidRequest:${tab}`))}
            index={props.tabIndex}
            className="tabs__button"
          />
          <div className="Prepaid-Request-header__tabs__actions">
            <Actions.ResultsPerPage
              value={props.pageSize}
              onChange={props.onPageSizeChange}
            />
          </div>
        </div>
        <div>
            {openWarningMessage.isJobOpen && (
              <WarningMessageModal
                onProceed={handleNewJobProceed}
                onCancel={handleCancle}
                section="Submission"/>
            )}
            {openWarningMessage.isSupplyOpen && (
              <WarningMessageModal
                  onProceed={handleNewSupplyProceed}
                  onCancel={handleCancle}
                  section="Supply"/>
            )}
        </div>
      </div>
  );
};

PrepaidRequestHeader.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
  pageSize: PropTypes.arrayOf(PropTypes.number),
  onTabsClick: PropTypes.func,
  onUpload: PropTypes.func,
  isSubmissionWarningON: PropTypes.bool,
  deleteSelectedItems: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};

export default PrepaidRequestHeader;



// WEBPACK FOOTER //
// ./src/containers/PrepaidRequest/PrepaidRequestHeader/PrepaidRequestHeader.jsx